import axiosClient from '../axiosClient';

const photoService = {
  async getPhotos(filters = {}) {
    try {
      const response = await axiosClient.get('/photo', {
        params: filters,
      });
      return response.data.data;
    } catch (error) {
      return Promise.reject(error.response?.data?.message || "errors.failed_to_fetch_data");
    }
  },
  async deletePhoto(id) {
    try {
      const response = await axiosClient.delete(`/photo/${id}`);
      return response.data;
    } catch (error) {
      return Promise.reject(error.response?.data?.message || "Failed to delete photo");
    }
  }  
};

export default photoService;
